module.exports = __webpack_public_path__ + "static/img/zhizhao.4987d461.png";